<template>
<div>
<div class="modal tags-browse-dialog-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header p-2">
        <h6 class="modal-title">{{$t('Select Tags')}}</h6>
        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeTagsBrowse">
          <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
        </button>
      </div>
      <div class="modal-body">
          <div class="col-md-12 search-bar-comm-style">
                <input type="text" id="selecttagsinputfield" v-model="search" @input="displayFilteredTags()" class="bg-transparent rounded text-light" style="width:45%" ref="focus" placeholder="Search...">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-search" fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                    <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                </svg>
            </div>
            <div class="col-md-12 mt-1">
                <ul v-if="tagsList.length !=0" class="tags-display-ul p-0 active-tag">
                        <!-- <li id="tag_field" v-for="tag in filteredTags" :key="tag._id" v-on:click="selectTags(tag)"
                         :class="['view-tags', {activeTag: selectedTagList.includes(tag._id)} ]"> -->
                         <li id="tag_field" v-for="tag in tagsList" :key="tag._id" tabindex="0" v-on:click="selectTags(tag)"
                         :class="['view-tags', {activeTag: ( tagIdList.includes(tag._id) )} ]">
                         <span>{{tag.name}}</span>
                        </li>
                </ul>
            </div>
      </div>
      <div style="background: #121212;margin-top:6px;">
        <pagination
          v-model="page"
          :records="totalTags"
          :per-page="perPage"
          @paginate="paginate"
          ref="paginationPlugin"
        />
      </div>
      <div class="modal-footer p-0 primary-btn-style" style="justify-content:space-between">
        <div><button tabindex="0" v-if="isPrivilegeExists('manage-tags')" class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;float:inline-start" v-on:click="createdTagsThroughBrowse">New</button></div>
        <div><button tabindex="0" class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;" data-dismiss="modal" v-on:click="closeTagsBrowse">Cancel</button>
        <button tabindex="0" id="tagmetadataaddbtn" class="btn btn-outline-primary ml-1 mr-2" v-on:click="saveTagsSelectedFromBrowse()">Add</button></div>
      </div>
    </div>
  </div>
</div>
<add-tag class="add-tags-inside-tags-browse-dialog"
      v-show="isAddTagModalVisible"
      @close="closeAddTagModal"></add-tag>
</div>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from "vuex"
import Pagination from "vue-pagination-2";
import cancelIcon from "../core/InlineCancelField.vue";
import addTag from "./AddTag.vue";
import Utils from "../../components.utils.js";
import {NotifierConstants} from "../../components.constants.js";

export default {
    data(){
        return{
        tagsList:[],
        search: null,
        selectedTagList:[],
        selectedTagIdNameMap:{},
        tagIdList:[],
        page:1,
        totalTags:-1,
        perPage:-1,
        isAddTagModalVisible: false,
        }
    },
    components:{
      pagination: Pagination,
        'cancel-icon':cancelIcon,
        "add-tag": addTag,
    },
    props: ["fileInfo","refreshFileInfoAndShowAsset", "selectedTagsFromParent"],
    emits: ['close'],
     methods: {
        isPrivilegeExists(privilegeName){
          return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, privilegeName);
        },
        updateAndCloseTagsBrowse(){
          let payload = {metadata :{"tag_ids": this.selectedTagList}}
          if ("asset_id" in this.fileInfo){
            payload._id = this.fileInfo.asset_id
          }else{
            payload._id = this.fileInfo._id
          }
          this.updateAssetInfo(payload).then((data)=>{
            if (data.statusCode==200){
              // this.refreshFileInfoAndShowAsset(this.fileInfo._id) "Uncomment later when tags issue is fixed, DAM-56 and DAM-133."
              this.$toast.success((data.message!=undefined?data.message:"Asset updated"));
            }else{
                this.$toast.error((data.message!=undefined?data.message:"Failed to update asset"));
            }
          })
          this.search = null
          this.closeTagsBrowse()
        },
        saveTagsSelectedFromBrowse(){
          this.$emit("saveTagsSelectedFromBrowse",this.selectedTagList)
        },
        createdTagsThroughBrowse(){
          this.isAddTagModalVisible = true;
        },
        closeAddTagModal(){
            this.isAddTagModalVisible = false;
            this.displayFilteredTags();
        },
        getSelectedTagIdNameMapper(){
          return this.selectedTagIdNameMap;
        },
        closeTagsBrowse(){
          if(typeof(this.selectedTagList) == "undefined"){
            this.$emit('close',[])
            return
          }
          this.$emit('close')
        },
        getSelectedTagIdList(){
         return this.tagIdList;
        },
        selectTags(tag){
          if(!(this.tagIdList.includes(tag._id))){
            this.selectedTagList.push(tag);
            this.tagIdList.push(tag._id)
            this.selectedTagIdNameMap[tag._id] = tag.name;
          }else{
            this.tagIdList = this.tagIdList.filter((t)=>t !=tag._id)
            this.selectedTagList = this.selectedTagList.filter((t)=>t._id !=tag._id)
            delete this.selectedTagIdNameMap[tag._id];
          }
        },
        displayFilteredTags(){
          let payload ={}
          if(this.search.length > 0){
            payload.params = {name:this.search};
            this.getTagsOnAutocomplete(payload).then((data) => {
              this.tagsList = data["tags"].filter(op=>(op.name.toLowerCase().startsWith(this.search.toLowerCase())));
              this.page= 1;
              this.totalPages= -1;
              this.totalTags= -1;
              this.perPage= -1;
            });
          }else{
            this.refreshTagsFromServer()
          }
          
        },
        paginate(){
          // this.page = page  // not required as v-model that job of setting page variable
          this.refreshTagsFromServer();
        },
        add_to_taglist(tag_info){
          let tag_exists = this.tagsList.filter((tag)=>tag._id==tag_info._id)
          if (tag_exists.length ==0){
            this.tagsList.push(tag_info)
          }else{
            Object.assign(tag_exists[0], tag_info)
          }
        },
        refreshTagsFromServer(){
          this.$nextTick(() => {
            let payload ={params:{page:this.page, limit:100}}
             this.getAllTagsFromServer(payload).then((data)=>{
                this.tagsList = []
                for (const tag_info of data["tags"]) {
                  this.add_to_taglist(tag_info) 
                }
                // this.page = data["page"];
                this.totalTags = data["total_tags"];
                this.perPage = data["tags_per_page"];
                // this.$refs.paginationPlugin.setPage(this.page);
              })
          });
        },
        handleTagNotification(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          if(notification.message){
            let tag_info = notification.message
            if (notification.message_type == NotifierConstants.tagRemovedNotification){
              this.tagsList = this.tagsList.filter((tag)=>tag._id!=tag_info._id)
            }else{
              this.add_to_taglist(tag_info)
            }
          }
        },
        registerforWebsocketNotifications(){
          this.addWSEventListener({
                eventname:[NotifierConstants.tagCreatedNotification, NotifierConstants.tagModifiedNotification, NotifierConstants.tagRemovedNotification],
                callback:this.handleTagNotification,
                parent:"TagsBrowse"})
        },
        unRegisterforWebsocketNotifications(){
          this.removeWSEventListener({
                eventname:[NotifierConstants.tagCreatedNotification, NotifierConstants.tagModifiedNotification, NotifierConstants.tagRemovedNotification],
                callback:this.handleTagNotification,
                parent:"TagsBrowse"})
        },
        getTagIdList(tags){
          let temp = [];
          for(let t = 0; t< tags.length; t++){
            temp.push(tags[t]._id)
          }
          return temp;
        },
        handleKeyBoardShortcutsAndTabPressTagmetadata(event){
           let keyCode = event.keyCode || event.which;
           if(keyCode == 13){ // enter key
              console.log('active tag',document.activeElement);
              document.activeElement.click();
           } 
           if(keyCode == 27){
               document.getElementById('tagmetadataaddbtn').focus();
           }
        },
        ...mapActions("tags",["getAllTagsFromServer","getTagsOnAutocomplete"]),
        ...mapActions("assets", ["updateAssetInfo"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    },
    created(){
      this.registerforWebsocketNotifications()
      this.refreshTagsFromServer();
      if(this.selectedTagsFromParent != undefined && this.selectedTagsFromParent.length){
        this.tagIdList = this.getTagIdList(this.selectedTagsFromParent); 
      }
      this.selectedTagList = JSON.parse(JSON.stringify(this.selectedTagsFromParent)); 
    },
    computed: {
      ...mapGetters("users",["getLoggedInUserPrivilege"]),
      filteredTags () {
        if (!this.tagsList.length) {
          return []
        }
        return this.tagsList.filter(item => {
          let props = Object.values(item);
          return props.some(prop => !this.search || ((typeof prop === 'string') ? prop.includes(this.search) : prop.toString(10).includes(this.search)))
        })
      }
  },

  mounted(){
    window.addEventListener('keydown', this.handleKeyBoardShortcutsAndTabPressTagmetadata);
    document.getElementById('selecttagsinputfield').focus();
  },
  beforeDestroy(){
    console.log('global event listener removed');
      window.removeEventListener('keydown', this.handleKeyBoardShortcutsAndTabPressTagmetadata);
    this.unRegisterforWebsocketNotifications()
  }
}
</script>

<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue : #007bff;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$tags-background-color:#272727;
$tags-border-color:#363636;
.modal-dialog {
    max-width: 500px;
    width: 500px;
    height: 400px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $body-bg-color !important;
    border: $modal-border;
    .modal-body{
      background: $modal-background;
      height:300px;
      overflow:auto;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 20%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}

.btn{
    font-size:14px !important;
    height:100%;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #141414;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #333;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border: none !important;
    background: $header-background;
    .modal-title{
      color:$header-color;
    }
}

ul{
    list-style-type: none;
}

.primary-btn-style {
  margin-top: 1%;
  height:55px;
  justify-content: flex-end;
  button {
    height: 35px;
    width: 70px;
    border-radius: 5px;
    font-size:14px;
  }
}

.search-bar-comm-style{
  height:55px;
  position:relative;
  input{
    border:1px solid #202020;
    height: 35px;
    padding-inline-start: 7%;
  }
  svg{
    position: absolute;
    inset-inline-start: 21px;
    top: 40%;
  }
}

.secondary-btn-style{
  color:$text-color;
}

.modal-footer{
    justify-content: flex-end;
}

.view-tags{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border: 1px solid $tags-border-color !important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: center;
    width:auto !important;
    background: $tags-background-color;
    color: $text-color;
    span{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 2px;
    }
}

.view-tags:hover{
    border: 1px solid #3a3a3a !important;
}

.activeTag{
    color: $active-blue !important;
}

.secondary-btn-style:hover{
  text-decoration: underline;
}

// //pagination
::v-deep {
.page-item.disabled .page-link {
  background-color: #0d0d0d !important;
  border: 1px solid #333 !important;
  // border: none;
}
.page-item.active .page-link {
  background-color: #0d0d0d !important;
  // border: none !important;
  border: 1px solid #333 !important;
  color:$active-blue;
}
.page-link {
  background-color: #0d0d0d !important;
  border: 1px solid #333 !important;
  // border: none !important;
  color:$text-color;
  padding: 5px !important;
}
.page-link:hover {
  background-color: #1a1a1a !important;
}
.pagination {
  float: inline-end;
  margin-bottom: 0px !important;
  margin-inline-end: 8px;
}
.VuePagination__count {
  color: #797979 !important;
  margin-bottom: 0px !important;
  font-size: 12px;
  margin-inline-end: 7px;
  margin-top: 1px;
  float:inline-start;
  display:none;
  margin-inline-start:5px;
}
.VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
}
.VuePagination__pagination-item-prev-chunk {
  display:none;
}
.VuePagination__pagination-item-next-chunk{
  display:none;
}
.VuePagination__pagination-item-prev-page{
  width:50px !important;
}

.VuePagination__pagination-item-next-page{
  width:50px !important;
}

.VuePagination__pagination-item-next-page a:before{
  width:50px;
  content: "next ";
}

.VuePagination__pagination-item-prev-page a:after{
  width:50px;
  content: " prev";
}
.v-list{
  padding:0px !important;
}
.v-list-item{
  text-align: start;
  border: 1px solid #242424 !important;
  min-height: 37px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
    .v-list-item__title{
          font-size: 14px !important;
          color:$text-color !important;
    }
  }
.v-menu__content{
  width:150px !important;
}
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}
</style>